import { render, staticRenderFns } from "./TransferAccountInfo.vue?vue&type=template&id=152c7825&scoped=true"
import script from "./TransferAccountInfo.vue?vue&type=script&lang=js"
export * from "./TransferAccountInfo.vue?vue&type=script&lang=js"
import style0 from "./TransferAccountInfo.vue?vue&type=style&index=0&id=152c7825&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c7825",
  null
  
)

export default component.exports